import {AxiosInstance} from "axios";
import {
    NotificationTemplate,
    NotificationTemplateTag,
    NotificationTemplateType
} from "@/notification-template/interfaces";

export interface NotificationTemplateIndexParams {
    type?: NotificationTemplateType;
    types?: NotificationTemplateType[];
    program_id?: number | null;
    customer_id?: number;
    laboratory_id?: number;
    survey_id?: number;
    targetable_types?: ('program' | 'laboratory' | 'none')[];
}

export interface FeatureNotificationTemplateParams {
    feature: string;
    customer_id: number;
}

export interface NotificationTemplateTagParams {
    types?: 'laboratory' | 'program'
}

export default function (client: AxiosInstance) {
    return {
        /**
         * Get the mass certification message template index.
         *
         * @return {Promise<Array>}
         */
        async index(params: NotificationTemplateIndexParams = {}): Promise<NotificationTemplate[]> {
            return client.get('mass-certification/notification-templates', {params})
                .then(response => response.data.data);
        },

        /**
         * Get the available tags to filter notification templates.
         */
        async tags(params: NotificationTemplateTagParams = {}): Promise<NotificationTemplateTag[]> {
            return client.get('notification-templates/tags', {params})
                .then(response => response.data.data);
        },

        /**
         * Fetch the notification templates scoped with a given customer.
         * @param params
         */
        async feature(params: FeatureNotificationTemplateParams): Promise<NotificationTemplate[]> {
            return client.get('notification-templates/feature', {params})
                .then(response => response.data.data);
        },

        /**
         * Try a notification template by sending a test message to the given phone number.
         */
        async tryTemplate(templateId: number, phone: string): Promise<{success: boolean}> {
            return client.post(`notification-templates/${templateId}/try`, {data: {phone}})
                .then(response => response.data.data);
        }
    };
}
